/* eslint no-console: 0 */

import '@babel/polyfill'
import 'whatwg-fetch'
import "core-js/modules/es7.promise.finally"
import Vue from 'vue'
Vue.config.devtools = true
import VueRouter from 'vue-router'
import router from '../router'
import App from '../components/app.vue'
import 'components'
import VideoPlayer from '../vendor/video-player.vue'
import '../vendor/videojs-youtube.js'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'
import { Drag, Drop } from 'vue-drag-drop'
import introspectionQueryResultData from '../generated/fragment-types.json'
import '../styles/app.stylus'

import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import cookie from 'cookie'
import VueApollo from 'vue-apollo'
import AsyncComputed from 'vue-async-computed'
import de from 'vuetify/es5/locale/de'

Vue.config.productionTip = false
Vue.component('drag', Drag)
Vue.component('drop', Drop)
Vue.use(AsyncComputed)
Vue.use(VueResource)
Vue.use(VueApollo)
Vue.use(VueRouter)
Vue.use(Vuetify, {
  lang: {
    locales: { de },
    current: 'de'
  },
  theme: {
    primary: '#0053a6',
    secondary: '#009dd1',
  }
})

Vue.component('video-player', VideoPlayer)
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyBTCixG9zDRD8izi_5jY3J-Ov1oi9HCLTc' } })

Vue.http.interceptors.push((request, next) => {
  const token = cookie.parse(document.cookie).authenticity_token
  if (token && request.url && request.url.startsWith(location.origin) || /^\/([^/]|$)/.test(request.url)) {
    request.headers.set('X-CSRF-Token', token)
  }
  next()
})

function apolloProvider() {
  const httpLink = new HttpLink({ uri: '/graphql' })
  const middlewareLink = new ApolloLink((operation, forward) => {
    // This function is called before every request.
    const authenticityToken = cookie.parse(document.cookie).authenticity_token
    operation.setContext({
      credentials: 'include',
      headers: {
        'X-CSRF-Token': authenticityToken
      }
    })
    return forward(operation)
  })
  const link = middlewareLink.concat(httpLink)
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })
  const apolloClient = new ApolloClient({
    link: link,
    cache: new InMemoryCache({fragmentMatcher}),
    connectToDevTools: true,
  })

  return new VueApollo({ defaultClient: apolloClient })
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.jsOK) {
    const el = document.body.appendChild(document.createElement('app'))
    const app = new Vue({
      el,
      router,
      apolloProvider: apolloProvider(),
      render: h => h(App)
    })
  }
})
